import { useEffect, useState } from 'react';

/**
 * Store local component state in LocalStorage
 *
 * @param {String} key LocalStorage key
 * @param {Mixed} defaultValue Value to store in LocalStorage
 * @returns {Array}
 * @link https://dev.to/selbekk/persisting-your-react-state-in-9-lines-of-code-9go
 */
function usePersistedState(key, defaultValue) {
  const [state, setState] = useState(
    () => JSON.parse(localStorage.getItem(key)) || defaultValue,
  );

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(state));
  }, [key, state]);

  return [state, setState];
}

export default usePersistedState;
